import { ChangeEvent } from 'react';
import {
  Button,
  Grid,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
} from '@mui/material';
import Iconify from '@/components/Iconify';
import { TransactionFilters, TransactionOption } from '../types';

type TransactionsTableToolbarProps = {
  filters: TransactionFilters;
  onFilters: (name: keyof TransactionFilters, value: string) => void;
  onResetFilters: () => void;
  statusOptions: TransactionOption[];
  typeOptions: TransactionOption[];
  sourceOptions: TransactionOption[];
  isFiltered: boolean;
};

export default function TransactionsTableToolbar({
  filters,
  onFilters,
  onResetFilters,
  statusOptions,
  typeOptions,
  sourceOptions,
  isFiltered,
}: TransactionsTableToolbarProps) {
  const handleQueryChange = (event: ChangeEvent<HTMLInputElement>) => {
    onFilters('query', event.target.value);
  };

  const handleSelectChange = (
    key: keyof TransactionFilters
  ) => (event: ChangeEvent<HTMLInputElement>) => {
    onFilters(key, event.target.value);
  };

  return (
    <Grid container spacing={2} sx={{ py: 2.5, px: 3 }}>
      <Grid item xs={12} md={4} lg={3}>
        <TextField
          value={filters.query}
          onChange={handleQueryChange}
          fullWidth
          size="small"
          placeholder="Search transactions"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-outline" width={20} />
              </InputAdornment>
            ),
          }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          select
          fullWidth
          size="small"
          label="Status"
          value={filters.status}
          onChange={handleSelectChange('status')}
        >
          <MenuItem value="">All</MenuItem>
          {statusOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          select
          fullWidth
          size="small"
          label="Type"
          value={filters.type}
          onChange={handleSelectChange('type')}
        >
          <MenuItem value="">All</MenuItem>
          {typeOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          select
          fullWidth
          size="small"
          label="Source"
          value={filters.source}
          onChange={handleSelectChange('source')}
        >
          <MenuItem value="">All</MenuItem>
          {sourceOptions.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      {isFiltered && (
        <Grid item xs={12}>
          <Stack direction="row" justifyContent="flex-end">
            <Button
              color="inherit"
              onClick={onResetFilters}
              startIcon={<Iconify icon="eva:close-circle-outline" />}
            >
              Reset filters
            </Button>
          </Stack>
        </Grid>
      )}
    </Grid>
  );
}
